import axios from "axios";

const getBaseUrl = () => {
  if (window.location.hostname === "localhost") {
    // Assumes hwandudaedo backend is running on port 8004
    return "http://localhost:8004/api/";
  } else {
    return `https://${window.location.hostname}/api/`;
  }
};

const AxiosInstance = axios.create({
  baseURL: getBaseUrl(),
  responseType: "json",
  headers: {
    "X-Requested-With": "XMLHttpRequest",
    "Content-Type": "application/json",
  },
});

export default AxiosInstance;
